<template>
  <div
    class="dashboard-all"
    :style="{
      height:
        config_paging && config_hidden_header && !props.showEdit ? 'calc(100% - 30px)' : '100%',
    }"
  >
    <div class="dataUC">
      <div class="dataUC__header">
        <div class="dataUC__header-left">
          <!-- <div class="dataUC__header__pagination" v-if="showMenu">
                  <list-pagination
                  :listPagesCount="tableRules.lengthMenu"
                  :pageSize="tableRules.limit"
                  @changePageFromListPagination="changePageFromListPagination"
                  >
                  </list-pagination>
              </div> -->
          <div class="dataUC__header__showCol">
            <list-columns-name
              :listColumns="dataTable.columnsOptionHide"
              :listColHide="listColHide"
              :countCloseListColumnsName="countCloseListColumnsName"
              :idItem="props?.item?.id"
              type="table-screen"
              @showColumn="showColumn"
              @hideColumn="hideColumn"
              @closeListFilter="closeListFilter"
              @closeWarningData="closeWarningData"
            ></list-columns-name>
          </div>
        </div>
        <div class="dataUC__header-mid">
          <div class="dataUC__header__filter">
            <list-columns-filter
              :listColumns="dataTable.selectColumnsToFilter"
              :countCloseListFilter="countCloseListFilter"
              :nameFilterURL="nameFilterURL"
              @nameColumnToFilter="nameColumnToFilterPlacehoder"
              @closeListColumnsName="closeListColumnsName"
              @closeWarningData="closeWarningData"
              :key="keyListColumnsFilter"
            ></list-columns-filter>
            <div
              class="dataUC__header__filter-icon"
              style="background-color: #fff"
            >
              <span class="icon is-small is-left">
                <svg
                  class="svg-inline--fa fa-search"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="search"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    class=""
                    fill="currentColor"
                    d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                  ></path>
                </svg>
              </span>
              <el-input
                v-model="inputSearch"
                class="w-100 element_filter"
                :placeholder="
                  $t('t_input_column_search_value', {
                    msg: nameColumnToFilter,
                  })
                "
                @keyup.enter="searchIfChanged"
                @blur="searchIfChanged"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="dataUC__body">
        <table-screen-component
          :item="dataCarditem"
          :itemData="dataTable.result"
          :isLoading="loadingData"
          :configTable="dataCarditem.table?.format"
          :configPaging="dataCarditem.table?.isPaging"
          :listColumnsStatus="listColumnsStatus"
          type="dashboard"
          :tableRules="props.itemTableRules"
          @getDataTableWhenSort="fn_tableSortChange"
          @showDialogDashboardPopupFromTableScreenComponent="
            showDialogDashboardPopupFromTableScreenComponent
          "
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref, onMounted, reactive, watch } from "vue";
import MethodService from "../../service/MethodService";
import DataForm from "./dataTableScreen";
import { useRoute } from "vue-router";
// import ListPagination from "../ListPagination.vue";
import ListColumnsName from "../ListColumnsName.vue";
import ListColumnsFilter from "../ListColumnsFilter";
import TableScreenComponent from "./TableScreenComponent.vue";
import { Card_item } from "cem-probe-api";
import { useUrlPopupStore } from "@/stores/urlPopupStore";
const storeUrlPopup = useUrlPopupStore();
const emit = defineEmits([]);
const props = defineProps({
  item: Card_item,
  itemData: null,
  checkShowDown: Boolean,
  itemTableRules: Object,
  is_hiddenCardHeader: Boolean,
  showEdit: Boolean,
});
const loadingData = ref(false);
const tableRules = reactive(MethodService.copyObject(DataForm.tableRules));
const config_paging = ref(props.item.table?.isPaging);
const config_hidden_header = ref(props.item.general?.header?.is_hidden);
const route = useRoute();
const showMenu = ref(false);
const dataTable = reactive({
  data: [],
  result: [],
  columnsOptionHide: [],
  selectColumnsToFilter: [],
  total: 0,
  totalPages: 0,
});
const idCardItem = ref();
const dataCarditem = ref({});
const listColHide = ref([]);
const countCloseListColumnsName = ref(0);
const countCloseListFilter = ref(0);
const countCloseWarningData = ref(0);
const nameFilterURL = ref("");
const nameColumnToFilter = ref("");
const valueColumnToFilter = ref("");
const typeColumnToFilter = ref("datepicker");
const inputSearch = ref("");
const lastFilterKey = ref("");
const lastFilterValue = ref("");
const isInitialLoad = ref(true);
const keyListColumnsFilter = ref(0);
const listColumnsStatus = ref([]);
const tableRulesOffset = ref(0);
const showDialogDashboardPopupFromTableScreenComponent = (
  id,
  y,
  value,
  kpu
) => {
  const chartUrl = MethodService.renderLinkChart(
    {
      y: y,
      value: value,
      kpu: kpu,
    },
    null
  );
  storeUrlPopup.initUrlPopup();
  storeUrlPopup.pushUrlPopup(chartUrl);
  emit("showDialogDashboardPopup", id, chartUrl);
};
const changeDataSource = (data) => {
  dataTable.data = [];
  dataTable.result = data;
  dataTable.total = data?.total ?? 0;
  dataTable.totalPages = Math.ceil(dataTable.total / tableRules.limit);

  data.data?.forEach((item) => {
    let obj = {};
    item.forEach((item1, index1) => {
      if (!data.columns[index1] || !data.columns[index1].code) return;
      obj[data.columns[index1].code] = item1;
    });
    dataTable.data.push(obj);
  });
  if (props.itemTableRules.offset || props.itemTableRules.offset === 0)
    tableRulesOffset.value = props.itemTableRules.offset;
};

const setCardItem = () => {
  showMenu.value = dataCarditem.value.table?.isPaging ?? false;

  idCardItem.value = dataCarditem.value.id;
  dataTable.selectColumnsToFilter = [];
  dataTable.columnsOptionHide = [];
  listColHide.value = [];

  const hasColumnConfig =
    dataCarditem.value.table?.format &&
    dataCarditem.value.table.format.length > 0;

  if (hasColumnConfig) {
    dataCarditem.value.table.format.forEach((item) => {
      if (item.filter.is_allowed)
        dataTable.selectColumnsToFilter.push({
          value: item?.field_name,
          label: item.title_name || item.field_name,
          type: item.filter?.input_type ? item.filter.input_type : "input",
        });
      if (item.field_name && item.visible) {
        dataTable.columnsOptionHide.push({
          value: item.field_name,
          label: item.title_name || item.field_name,
          field_name: item.field_name,
        });
        if (item.visible && !item?.defaultHide)
          listColumnsStatus.value.push(item.field_name);
        if (item?.defaultHide) listColHide.value.push(item?.field_name);
      }
    });
  } else if (props.itemData?.columns?.length > 0) {
    // Không có cấu hình cột, tự động hiển thị tất cả columns từ API
    listColumnsStatus.value = props.itemData.columns
      .filter((col) => col.field_name)
      .map((col) => col.field_name);
  }

  if (props.itemData) changeDataSource(props.itemData);
};

const showColumn = (nameColumn) => {
  listColumnsStatus.value.push(nameColumn);
  emit("columnsOnScreen", listColumnsStatus.value);
};

const hideColumn = (nameColumn) => {
  listColumnsStatus.value = listColumnsStatus.value.filter(
    (item) => item !== nameColumn
  );
  emit("columnsOnScreen", listColumnsStatus.value);
};

const filterData = async () => {
  const keySearch =
    valueColumnToFilter.value ?? dataTable.selectColumnsToFilter[0]?.value ?? "";

  tableRules.filterKey = keySearch;
  tableRules.filterValue = inputSearch.value;
  lastFilterKey.value = keySearch;
  lastFilterValue.value = inputSearch.value;
  emit("filterData", tableRules.sort, keySearch, inputSearch.value, "filter");
};

const searchIfChanged = async () => {
  const keySearch =
    valueColumnToFilter.value ?? dataTable.selectColumnsToFilter[0]?.value ?? "";
  if (!inputSearch.value && !lastFilterValue.value) {
    lastFilterKey.value = keySearch;
    return;
  }
  if (
    keySearch !== lastFilterKey.value ||
    inputSearch.value !== lastFilterValue.value
  ) {
    await filterData();
  }
};

const closeListFilter = () => {
  countCloseListFilter.value += 1;
};
const closeWarningData = () => {
  countCloseWarningData.value += 1;
};

const nameColumnToFilterPlacehoder = (nameColumn, valueColumn, typeColumn) => {
  nameColumnToFilter.value = nameColumn;
  valueColumnToFilter.value = valueColumn;
  typeColumnToFilter.value = typeColumn ? typeColumn : "datepicker";
  if (isInitialLoad.value) {
    if (!tableRules.filterKey) inputSearch.value = "";
  }

  if (!isInitialLoad.value) {
    searchIfChanged();
  }
};

const closeListColumnsName = () => {
  countCloseListColumnsName.value += 1;
};

const fn_tableSortChange = async (column, order) => {
  dataTable.columnsOptionHide.forEach((item) => {
    if (item.value === column.prop) column.prop = item.field_name;
  });
  tableRules.sort = order;
  emit(
    "filterData",
    tableRules.sort,
    tableRules.filterKey,
    tableRules.filterValue,
    "sort"
  );
};

// const changePageFromListPagination = (pageSize) => {
//   fn_tableSizeChange(pageSize);
// };

// phân trang
// const fn_tableSizeChange = (limit) => {
//   tableRules.limit = limit;
//   fn_tableChangeOffset(tableRules.page);
// };
// const fn_tableChangeOffset = async (page) => {
//   tableRules.page = page;
//   tableRules.offset = (tableRules.page - 1) * tableRules.limit;
//   await getDataSource(idCardItem.value);
// };

const getInfoURL = () => {
  if (route.query.$sort) {
    let strSort = route.query.$sort;
    let objSort = {};
    if (strSort.includes("-")) {
      let keySort = strSort.toString().replace("-", "");
      objSort[keySort] = -1;
      tableRules.sort = objSort;
    } else {
      objSort[strSort] = 1;
      tableRules.sort = objSort;
    }
    tableRules.defaultSort[0] = tableRules.sort;
    route.query.$sort.indexOf("-") !== -1
      ? (tableRules.defaultSort[1] = "descending")
      : (tableRules.defaultSort[1] = "ascending");
  }
  if (route.query.$colfilter) {
    nameFilterURL.value = route.query.$colfilter;
    let strFilterURL = route.query.$colfilter;
    let index = strFilterURL.toString().indexOf(":");
    tableRules.filterKey = strFilterURL.toString().slice(0, index);
    tableRules.filterValue = strFilterURL.toString().slice(index + 1);
    inputSearch.value = tableRules.filterValue;
    lastFilterKey.value = tableRules.filterKey;
    lastFilterValue.value = tableRules.filterValue;
  }
  if (route.query.$limit) {
    tableRules.limit = Number(route.query.$limit);
  }
};

watch(
  () => props.item,
  (newData) => {
    dataCarditem.value = newData;
    setCardItem();
  }
);

watch(
  () => props.itemData,
  (newData) => {
    dataCarditem.value = props.item;
    if (!props.itemData?.data) dataCarditem.value = {};
    changeDataSource(newData);

    // Nếu không có cấu hình cột nhưng API trả về columns, tự động hiển thị tất cả
    const hasNoColumnConfig =
      !dataCarditem.value?.table?.format ||
      dataCarditem.value.table.format.length === 0;
    if (hasNoColumnConfig && newData?.columns?.length > 0) {
      listColumnsStatus.value = newData.columns
        .filter((col) => col.field_name)
        .map((col) => col.field_name);
    }
  }
);

watch(
  () => props.itemTableRules,
  (newData) => {
    if (newData.offset) {
      tableRulesOffset.value = props.itemTableRules.offset;
    }
  }
);

onMounted(async () => {
  getInfoURL();
  keyListColumnsFilter.value += 1;
  dataCarditem.value = props.item;
  setCardItem();
  isInitialLoad.value = false;
});
</script>
<link
  type="scss"
  src="../../assets/scss/components/_table-screen-dashboard.scss"
/>
